import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappCrm = () => (
  <>
    <Helmet>
      <title>WhatsApp CRM for Customer Conversations | HAWKTRION</title>
      <meta name="description" content="Connect WhatsApp conversations with customer and lead records. Organize follow-ups, appointments, and messaging workflows with HAWKTRION CRM tools." />
      <meta name="keywords" content="WhatsApp CRM, WhatsApp customer management, WhatsApp CRM integration" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-crm/" />
      <meta property="og:title" content="WhatsApp CRM for Customer Conversations | HAWKTRION" />
      <meta property="og:description" content="Connect WhatsApp conversations with customer and lead records. Organize follow-ups, appointments, and messaging workflows with HAWKTRION CRM tools." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-crm/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp CRM for Customer Conversations | HAWKTRION" />
      <meta name="twitter:description" content="Connect WhatsApp conversations with customer and lead records. Organize follow-ups, appointments, and messaging workflows with HAWKTRION CRM tools." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp CRM for Customer and Lead Management" hideCta>
      <RemainingLandingContent pageKey="crm" />
    </SeoLandingPage>
  </>
);

export default WhatsappCrm;